import axiosClient, { unwrap } from "./axiosClient";
import { ENDPOINTS } from "./endpoints";

export const productApi = {
  getAll: () =>
    axiosClient.get(ENDPOINTS.bottleProducts.list).then(unwrap),

  getActive: () =>
    axiosClient.get(ENDPOINTS.bottleProducts.active).then(unwrap),

  create: (data) =>
    axiosClient.post(ENDPOINTS.bottleProducts.create, data).then(unwrap),

  update: (id, data) =>
    axiosClient.put(ENDPOINTS.bottleProducts.update(id), data).then(unwrap),

  setStatus: (id, status) =>
    axiosClient
      .patch(ENDPOINTS.bottleProducts.status(id), null, {
        params: { status },
      })
      .then(unwrap),

  uploadImage: (bottleId, file) => {
    const formData = new FormData();
    formData.append("file", file);

    return axiosClient
      .post(
        `/api/admin/file-assets/product-images/bottles/${bottleId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then(unwrap);
  },

  removeImage: (bottleId) =>
    axiosClient
      .delete(`/api/admin/file-assets/product-images/bottles/${bottleId}`)
      .then(unwrap),
};
